/**
 * HM finalist lazy route wrappers (routes/positions convention). Mounted in App.tsx
 * inside the AppShell ProtectedRoute tree, wrapped in RequireRole hiring_manager.
 */
import { lazy } from "react";

const HmFinalistDashboard = lazy(() =>
  import("@/features/hm/HmFinalistDashboard").then((m) => ({
    default: m.HmFinalistDashboard,
  })),
);

const HmFinalistDetailPage = lazy(() =>
  import("@/features/hm/HmFinalistDetailPage").then((m) => ({
    default: m.HmFinalistDetailPage,
  })),
);

export function HmFinalistDashboardRoute() {
  return <HmFinalistDashboard />;
}

export function HmFinalistDetailRoute() {
  return <HmFinalistDetailPage />;
}
